export class SurveyClicksCalculator {
  constructor(
    private readonly _completes: number,
    private readonly _expectedIr: number,
    private readonly _clickBalancing: boolean = true
  ) {}

  public calculate(): number {
    if (!this._clickBalancing) {
      return 0;
    }

    return Math.round((this._completes * 100) / this._expectedIr);
  }
}
